
import { Skeleton } from "@/components/ui/skeleton";

const DashboardSkeleton = () => {
  return (
    <>
      {/* Skeleton Navbar without actual content */}
      <div className="bg-white dark:bg-neutral-800 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-8 w-32" />
            <div className="flex space-x-4">
              <Skeleton className="h-8 w-20" />
              <Skeleton className="h-8 w-20" />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-24 min-h-screen">
        <div className="max-w-3xl mx-auto bg-white dark:bg-neutral-800 rounded-lg shadow-lg p-8">
          <Skeleton className="h-8 w-48 mb-6" />
          <div className="space-y-4">
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-6 w-1/2" />
          </div>
        </div>
      </div>
      {/* Skeleton Footer */}
      <div className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <Skeleton className="h-4 w-64 bg-gray-600" />
        </div>
      </div>
    </>
  );
};

export default DashboardSkeleton;
